export enum WhitelabelId {
    AGODA = 1,
    AGODAUAT = 101,
    JTB = 2,
    JTBUAT = 201,
    JAPANICAN = 3,
    JAPANICANUAT = 301,
    RURUBU = 4,
    RURUBUUAT = 401,
    PRICELINE = 5,
    ROCKETMILES = 10,
    ROCKETMILESUAT = 1001,
    WIKIBUY = 33,
    HOTELSTORM = 19,
    CITIUS = 51,
    CITIUSUAT1 = 5101,
    CITIUSUAT2 = 5102,
    CITIUSUAT3 = 5103,
}

// This is used for identifying WLs in migration process to Agoda infra
// based on which we skip certain features/configs
export const MIGRATING_WL_IDS = [WhitelabelId.ROCKETMILESUAT];
